/* WOZ STORE — V42.2 behaviour
   Boot hero, scroll-driven scenes, pinned best-seller shelf, shelves with
   paddles + drag + progress, reveal with fail-safes, decode text, count-up,
   product buy bar, gallery fit. No dependencies. */
(function () {
  'use strict';
  var doc = document.documentElement;
  doc.classList.add('ws-js'); window.__wsReady = true;
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var reduce = mqReduce.matches;
  var finePointer = !window.matchMedia('(pointer: coarse)').matches;
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function vh() { return window.innerHeight || doc.clientHeight; }

  /* ---------- Header height → CSS var (sticky scenes sit under it) ---------- */
  function headerH() {
    var h = document.querySelector('#site-header');
    if (!h) return 0;
    var r = h.getBoundingClientRect();
    return Math.max(0, Math.round(r.height));
  }
  function setHeaderVar() { doc.style.setProperty('--ws-hh', headerH() + 'px'); }

  /* ---------- Reveal ---------- */
  var pending = [];
  function initReveal(root) {
    var els = Array.prototype.slice.call((root || document).querySelectorAll('.ws-reveal:not(.is-in)'));
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.01 });
    els.forEach(function (e) { io.observe(e); pending.push(e); });
  }
  /* Fail-safe: anything at or above the viewport bottom is shown, even after fast jumps */
  function sweepReveal() {
    if (!pending.length) return;
    var lim = vh();
    pending = pending.filter(function (e) {
      if (e.classList.contains('is-in')) return false;
      if (e.getBoundingClientRect().top < lim) { e.classList.add('is-in'); return false; }
      return true;
    });
  }

  /* ---------- Shelves: paddles, drag, progress ---------- */
  function initShelves(root) {
    (root || document).querySelectorAll('[data-ws-shelf]').forEach(function (shelf) {
      if (shelf.__ws) return; shelf.__ws = true;
      var track = shelf.querySelector('.ws-shelf__track');
      if (!track) return;
      var paddles = shelf.querySelector('.ws-paddles');
      var bar = shelf.querySelector('.ws-shelf__progress span');
      var prev = paddles && paddles.querySelector('[data-dir="prev"]');
      var next = paddles && paddles.querySelector('[data-dir="next"]');
      function step() {
        var li = track.querySelector('li');
        var w = li ? li.getBoundingClientRect().width + 16 : 320;
        return Math.max(w, Math.floor((track.clientWidth - 40) / w) * w);
      }
      function update() {
        if (shelf.classList.contains('is-pinned')) return;
        var max = track.scrollWidth - track.clientWidth - 2;
        if (paddles) paddles.hidden = max <= 0;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        shelf.classList.toggle('has-overflow', max > 0);
        if (bar) {
          var vis = track.clientWidth / Math.max(track.scrollWidth, 1);
          bar.style.width = (vis * 100) + '%';
          bar.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * ((1 - vis) / vis) * 100 : 0) + '%)';
        }
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      /* Mouse drag (desktop). Touch keeps native swipe. Clicks still work. */
      if (finePointer) {
        var down = false, sx = 0, sl = 0, moved = false;
        track.addEventListener('pointerdown', function (e) {
          if (e.pointerType !== 'mouse' || e.button !== 0 || shelf.classList.contains('is-pinned')) return;
          down = true; moved = false; sx = e.clientX; sl = track.scrollLeft;
        });
        window.addEventListener('pointermove', function (e) {
          if (!down) return;
          var dx = e.clientX - sx;
          if (!moved && Math.abs(dx) > 6) { moved = true; track.classList.add('is-dragging'); }
          if (moved) { track.scrollLeft = sl - dx; e.preventDefault(); }
        });
        window.addEventListener('pointerup', function () {
          if (!down) return; down = false;
          if (moved) { setTimeout(function () { track.classList.remove('is-dragging'); }, 0); }
        });
        track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
        track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      }
      update(); setTimeout(update, 600); window.addEventListener('load', update);
    });
  }

  /* ---------- Pinned best-seller shelf (desktop, vertical scroll → sideways) ---------- */
  var pins = [];
  function initPins() {
    document.querySelectorAll('[data-ws-pin]').forEach(function (shelf) {
      if (shelf.__pin) return; shelf.__pin = true;
      pins.push({ el: shelf, track: shelf.querySelector('.ws-shelf__track'), pin: shelf.querySelector('.ws-shelf__pin') });
    });
    layoutPins();
  }
  function pinAllowed() { return !reduce && finePointer && window.innerWidth >= 1024; }
  function layoutPins() {
    pins.forEach(function (p) {
      var on = pinAllowed();
      p.el.classList.toggle('is-pinned', on);
      if (!on) { p.el.style.height = ''; p.track.style.transform = ''; p.dist = 0; return; }
      p.track.scrollLeft = 0;
      var f0 = p.track.firstElementChild, g = f0 ? Math.max(0, f0.getBoundingClientRect().left - p.track.getBoundingClientRect().left) : 0;
      p.dist = Math.max(0, p.track.scrollWidth - p.track.clientWidth + g);
      if (p.dist < 40) { p.el.classList.remove('is-pinned'); p.el.style.height = ''; return; }
      p.el.style.height = (p.pin.offsetHeight + p.dist) + 'px';
    });
  }
  function tickPins() {
    pins.forEach(function (p) {
      if (!p.el.classList.contains('is-pinned')) return;
      var r = p.el.getBoundingClientRect();
      var top = parseFloat(getComputedStyle(doc).getPropertyValue('--ws-hh')) || 0;
      var prog = clamp((top - r.top) / Math.max(p.dist, 1), 0, 1);
      p.track.style.transform = 'translate3d(' + (-prog * p.dist).toFixed(1) + 'px,0,0)';
      var bar = p.el.querySelector('.ws-shelf__progress span');
      if (bar) {
        var vis = p.track.clientWidth / Math.max(p.track.scrollWidth, 1);
        bar.style.width = (vis * 100) + '%';
        bar.style.transform = 'translateX(' + (prog * ((1 - vis) / vis) * 100) + '%)';
      }
    });
  }

  /* ---------- Scroll-driven scenes: write --p (0→1) ---------- */
  var scenes = [];
  function initScenes() {
    document.querySelectorAll('[data-ws-boot], [data-ws-cinema], [data-ws-scrub], [data-ws-parallax]').forEach(function (el) {
      if (el.__scene) return; el.__scene = true;
      var mode = el.hasAttribute('data-ws-boot') || el.hasAttribute('data-ws-cinema') ? 'pin' : 'pass';
      scenes.push({ el: el, mode: mode });
    });
  }
  function tickScenes() {
    var h = vh();
    var top = parseFloat(getComputedStyle(doc).getPropertyValue('--ws-hh')) || 0;
    scenes.forEach(function (s) {
      var r = s.el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > h + 200) return;
      var p;
      if (s.mode === 'pin') {
        var run = Math.max(r.height - (h - top), 1);
        p = clamp((top - r.top) / run, 0, 1);
      } else {
        p = clamp((h - r.top) / (h + r.height), 0, 1);
      }
      s.el.style.setProperty('--p', p.toFixed(4));
    });
  }

  /* ---------- Words scrub (cinema lede) ---------- */
  function initWords() {
    document.querySelectorAll('[data-ws-words]').forEach(function (el) {
      if (el.__w) return; el.__w = true;
      var words = el.textContent.trim().split(/\s+/);
      el.setAttribute('aria-label', el.textContent.trim());
      el.innerHTML = words.map(function (w, i) { return '<span class="ws-word" aria-hidden="true" style="--i:' + i + '">' + w.replace(/</g, '&lt;') + '</span>'; }).join(' ');
      el.style.setProperty('--n', words.length);
    });
  }

  /* ---------- Count-up + decode, once on entry ---------- */
  var GLYPHS = '#%&@$*+=<>/\\[]{}01';
  function decode(el) {
    var final = el.textContent; var frames = 18, f = 0;
    el.setAttribute('aria-label', final);
    function run() {
      f++;
      var out = '';
      for (var i = 0; i < final.length; i++) {
        var c = final[i];
        out += (c === ' ' || i < (f / frames) * final.length) ? c : GLYPHS[(Math.random() * GLYPHS.length) | 0];
      }
      el.textContent = out;
      if (f < frames) window.requestAnimationFrame(function () { setTimeout(run, 28); }); else el.textContent = final;
    }
    run();
  }
  function countUp(el) {
    var raw = el.textContent.trim();
    var m = raw.match(/^([^\d]*)([\d,]+)(.*)$/);
    if (!m || /–|-/.test(raw)) return;
    var target = parseInt(m[2].replace(/,/g, ''), 10), t0 = null, dur = 1200;
    function fmt(n) { return m[1] + n.toLocaleString('en-US') + m[3]; }
    function step(ts) {
      if (!t0) t0 = ts;
      var k = clamp((ts - t0) / dur, 0, 1); k = 1 - Math.pow(1 - k, 3);
      el.textContent = fmt(Math.round(target * k));
      if (k < 1) window.requestAnimationFrame(step); else el.textContent = raw;
    }
    window.requestAnimationFrame(step);
  }
  function initOnce() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        if (e.target.hasAttribute('data-ws-scramble')) decode(e.target); else countUp(e.target);
      });
    }, { threshold: 0.6 });
    document.querySelectorAll('[data-ws-scramble], [data-ws-count]').forEach(function (el) { io.observe(el); });
  }

  /* ---------- Boot hero ---------- */
  function initBoot() {
    var boot = document.querySelector('[data-ws-boot]');
    if (!boot) return;
    var lines = boot.querySelectorAll('.ws-boot__term p');
    var seen = false;
    try { seen = sessionStorage.getItem('wsBoot') === '1'; } catch (e) {}
    var timers = [];
    function done() {
      timers.forEach(clearTimeout); timers = [];
      lines.forEach(function (l) { l.innerHTML = l.getAttribute('data-line'); });
      boot.classList.remove('is-booting');
      boot.classList.add('is-booted');
      try { sessionStorage.setItem('wsBoot', '1'); } catch (e) {}
    }
    if (reduce || seen) { boot.classList.add('is-quick'); done(); return; }
    boot.classList.add('is-booting');
    var t = 260;
    lines.forEach(function (l, li) {
      var txt = l.getAttribute('data-line').replace(/&nbsp;/g, '\u00a0');
      for (let i = 1; i <= txt.length; i++) {
        timers.push(setTimeout(function () { l.textContent = txt.slice(0, i); l.classList.add('is-typing'); }, t));
        t += li === 3 ? 9 : 26;
      }
      timers.push(setTimeout(function () { l.classList.remove('is-typing'); }, t));
      t += li === 2 ? 340 : 160;
    });
    timers.push(setTimeout(done, t + 220));
    var skip = boot.querySelector('[data-ws-skip]');
    if (skip) skip.addEventListener('click', done);
    window.addEventListener('keydown', function onk(e) { if (e.key === 'Escape') { done(); window.removeEventListener('keydown', onk); } });
    window.addEventListener('scroll', function ons() { if (window.scrollY > 40) { done(); window.removeEventListener('scroll', ons); } }, { passive: true });
  }

  /* ---------- Product page buy bar ---------- */
  function initBuyBar() {
    if (!document.body.classList.contains('template-product')) return;
    var form = document.querySelector('.main-product .product-actions, .main-product product-form');
    var title = document.querySelector('.main-product .product__title, h1.product__title');
    if (!form || !title || document.querySelector('.ws-buybar')) return;
    var bar = document.createElement('div');
    bar.className = 'ws-buybar';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="ws-buybar__in"><span class="ws-buybar__title"></span><span class="ws-buybar__right"><span class="ws-buybar__price"></span><button type="button" class="ws-btn" tabindex="-1">Buy</button></span></div>';
    bar.querySelector('.ws-buybar__title').textContent = title.textContent.trim();
    document.body.appendChild(bar);
    var priceEl = document.querySelector('.main-product .main-product-price .product-price--original');
    function syncPrice() { bar.querySelector('.ws-buybar__price').textContent = priceEl ? priceEl.textContent.trim() : ''; }
    syncPrice();
    if (priceEl && 'MutationObserver' in window) new MutationObserver(syncPrice).observe(priceEl, { childList: true, characterData: true, subtree: true });
    bar.querySelector('button').addEventListener('click', function () {
      var top = form.getBoundingClientRect().top + window.scrollY - 140;
      window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
    });
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (en) {
      var off = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      bar.style.setProperty('--ws-buybar-top', headerH() + 'px');
      bar.classList.toggle('is-on', off);
      bar.setAttribute('aria-hidden', off ? 'false' : 'true');
      bar.querySelector('button').tabIndex = off ? 0 : -1;
    }, { threshold: 0 }).observe(form);
  }

  /* ---------- Product gallery: fill frame when the photo is close to its shape ---------- */
  function initGalleryFit() {
    if (!document.body.classList.contains('template-product')) return;
    document.querySelectorAll('.main-product .product-gallery-item img').forEach(function (img) {
      function fit() {
        var box = img.parentElement.getBoundingClientRect();
        if (!img.naturalWidth || !box.width || !box.height) return;
        var a = img.naturalWidth / img.naturalHeight, b = box.width / box.height;
        if (Math.abs(a - b) / b < 0.14) img.classList.add('ws-fill');
      }
      if (img.complete) fit(); else img.addEventListener('load', fit);
    });
  }

  /* ---------- Frame loop (only while scrolling / resizing) ---------- */
  var ticking = false;
  function frame() { ticking = false; tickScenes(); tickPins(); sweepReveal(); }
  function request() { if (!ticking) { ticking = true; window.requestAnimationFrame(frame); } }

  function boot() {
    setHeaderVar();
    initWords(); initReveal(); initShelves(); initPins(); initScenes(); initOnce(); initBoot(); initBuyBar(); initGalleryFit();
    frame();
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', function () { setHeaderVar(); layoutPins(); request(); }, { passive: true });
    window.addEventListener('load', function () { setHeaderVar(); layoutPins(); request(); });
    setTimeout(function () { setHeaderVar(); layoutPins(); request(); }, 900);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { initWords(); initReveal(e.target); initShelves(e.target); initPins(); initScenes(); request(); });
})();
